import { queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../core/api/queries";

export default createQueryGroup(({ api }) => {
  return {
    getSchemas: () =>
      queryOptions({
        queryKey: ["promptTesting", "schemas"],
        queryFn: async () => {
          return await api.get("./prompt_testing/schemas", {});
        },
      }),
  };
});
